import { ComboboxItem } from "@mantine/core";
import * as Tabs from "@radix-ui/react-tabs";

import { StyledTabsList } from "./Tabs.styled";


export const TabsRoot = ({ children, ...rest }: Tabs.TabsProps) => {
  return <Tabs.Root {...rest}>{children}</Tabs.Root>;
};

interface TabsListProps {
  comboboxItems?: ComboboxItem[];
  items?: string[];
  ariaLabel?: string;
}

export const TabsList = ({
  items,
  comboboxItems,
  ariaLabel,
}: TabsListProps) => {
  return (
    <StyledTabsList className="tabs-list" aria-label={ariaLabel}>
      {comboboxItems
        ? comboboxItems.map((item, id) => (
            <Tabs.Trigger
              className="tabs-trigger"
              value={item.value}
              key={id}
              disabled={item.disabled}>
              {item.label}
            </Tabs.Trigger>
          ))
        : items?.map((item, id) => (
            <Tabs.Trigger className="tabs-trigger" value={item} key={id}>
              {item}
            </Tabs.Trigger>
          ))}
    </StyledTabsList>
  );
};

export const TabsContent = ({ children, ...rest }: Tabs.TabsContentProps) => {
  return <Tabs.Content {...rest}>{children}</Tabs.Content>;
};
